// This file was AUTO-GENERATED by the Typewriter Visual Studio plugin base on the HandlerModels.tst template. 
// !!Do not modify this file or change may be lost!!
// SaveTypeOfProgramDetailsHandler
/* eslint-disable */
// @ts-ignore
import * as moment from 'moment';
import TypeOfProgramDTO from '../models/TypeOfProgramDTO';
import ResultDTO from '../models/ResultDTO';

interface Request {
    typeOfProgramId: number;
    typeOfProgram: TypeOfProgramDTO | null;
}

const Request = {
    create: (initValues?: Partial<Request> | Record<string, unknown> | null) => {
        return Object.assign(
        {
            typeOfProgramId: 0,
            typeOfProgram: null,
        },
        initValues);
    },
    typeOfProgramId: 'typeOfProgramId',
    typeOfProgram: 'typeOfProgram',
}

interface Result extends ResultDTO {
    typeOfProgram: TypeOfProgramDTO | null;
}

const Result = {
    create: (initValues?: Partial<Result> | Record<string, unknown> | null) => {
        return Object.assign(ResultDTO.create(),
        {
            typeOfProgram: null,
        },
        initValues);
    },
    typeOfProgram: 'typeOfProgram',
}

export { Request, Result };